import React from "react";
import { useEffect } from "react";
import { Count, Divider, Label, TimeBox, TimeContainer } from "./style";
import { useState } from "react";
import { getRemainingTime } from "./helpers";

function Time({ time, color, hasSeconds = true }) {
  const [timeLeft, setTimeLeft] = useState(0);
  const [remainingStamps, setRemainingStamps] = useState({
    days: "",
    hours: "",
    minutes: "",
    seconds: "",
  });

  const addZeroIfOneDecimal = (num) =>
    num.toString().length === 1 ? `0${num}` : `${num}`;

  const convertTimeToStamps = (remainingTime) => {
    const s = 1000;
    const m = 60000;
    const h = 3600000;
    const d = 86400000;

    const days = addZeroIfOneDecimal(Math.floor(remainingTime / d));
    const hours = addZeroIfOneDecimal(
      Math.floor((remainingTime - days * d) / h)
    );
    const minutes = addZeroIfOneDecimal(
      Math.floor((remainingTime - days * d - hours * h) / m)
    );
    const seconds = addZeroIfOneDecimal(
      Math.floor((remainingTime - days * d - hours * h - minutes * m) / s)
    );

    setRemainingStamps({ ...remainingStamps, days, hours, minutes, seconds });
  };

  useEffect(() => {
    convertTimeToStamps(timeLeft);
    if (timeLeft === undefined) return;

    if (timeLeft <= 1000) {
      return;
    }

    const interval = setTimeout(() => {
      setTimeLeft(timeLeft - 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  useEffect(() => {
    const remainingTime = getRemainingTime(time);
    setTimeLeft(remainingTime);
  }, [time]);

  return (
    <TimeContainer clr={color}>
      <TimeBox>
        <Count>{remainingStamps.days || 0}</Count>
        <Label>DAYS</Label>
      </TimeBox>
      <Divider />
      <TimeBox>
        <Count>{remainingStamps.hours || 0}</Count>
        <Label>HRS</Label>
      </TimeBox>
      <Divider />
      <TimeBox>
        <Count>{remainingStamps.minutes || 0}</Count>
        <Label>MIN</Label>
      </TimeBox>

      {hasSeconds && (
        <>
          <Divider />
          <TimeBox>
            <Count>{remainingStamps.seconds || 0}</Count>
            <Label>SEC</Label>
          </TimeBox>
        </>
      )}
    </TimeContainer>
  );
}

export default Time;
